import { Component } from '@angular/core';

@Component({
  selector: 'ltg-reset-password-done',
  templateUrl: './reset-password-done.component.html',
  styleUrls: ['./reset-password-done.component.css']
})
export class ResetPasswordDoneComponent { }



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/auth/reset-password/reset-password-done/reset-password-done.component.ts